import { render } from "./PrimaryCard.vue?vue&type=template&id=f7f7b1c6"
import script from "./PrimaryCard.vue?vue&type=script&lang=js"
export * from "./PrimaryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__